var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2424_1299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8824 15.5879C8.58412 15.5879 2 17.2432 2 20.5291V22.9997H21.7647V20.5291C21.7647 17.2432 15.1806 15.5879 11.8824 15.5879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.62 8.17647H17.1571C17.4906 8.17647 17.7624 7.90471 17.7624 7.57118V7.54647C17.7624 7.21294 17.4906 6.94118 17.1571 6.94118H16.8235C16.8235 5.11294 15.8229 3.54412 14.3529 2.67941V3.85294C14.3529 4.19882 14.0812 4.47059 13.7353 4.47059C13.3894 4.47059 13.1177 4.19882 13.1177 3.85294V2.17294C12.7224 2.07412 12.3147 2 11.8824 2C11.45 2 11.0424 2.07412 10.6471 2.17294V3.85294C10.6471 4.19882 10.3753 4.47059 10.0294 4.47059C9.68353 4.47059 9.41177 4.19882 9.41177 3.85294V2.67941C7.94177 3.54412 6.94118 5.11294 6.94118 6.94118H6.62C6.28647 6.94118 6.01471 7.21294 6.01471 7.54647V7.58353C6.01471 7.90471 6.28647 8.17647 6.62 8.17647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8824 13.118C14.18 13.118 16.0948 11.5368 16.6506 9.41211H7.11417C7.67005 11.5368 9.58475 13.118 11.8824 13.118Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2424_1299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkerIcon);
export default __webpack_public_path__ + "static/media/worker_icon.bbeaea9ce12ee622c965adc91cc4d02a.svg";
export { ForwardRef as ReactComponent };